import { urlsAreEqual, getUrl } from './urlUtils.js';
// Whether to render a nav item or not
export function shouldRenderNavItem({ item, loggedIn = false, cartCount = 0 }) {
    if (!item) {
        return false;
    }
    if (item.disabled) {
        return false;
    }
    if (item.hideWhenLoggedIn && loggedIn) {
        return false;
    }
    if (item.hideWhenLoggedOut && !loggedIn) {
        return false;
    }
    if (item.hideWhenCartEmpty && cartCount === 0) {
        return false;
    }
    if (item.hideWhenCartNotEmpty && cartCount !== 0) {
        return false;
    }
    return true;
}
// Whether to show a CTA in the CtaSubnav
export function shouldRenderCta({ data, currentUrl = getUrl(), loggedIn = false, cartCount = 0 }) {
    return (Boolean(data.cta) &&
        // CTA is not filtered out by logged in or cart state
        shouldRenderNavItem({
            item: data.cta,
            loggedIn,
            cartCount,
        }) &&
        // CTA should not be hidden due to current URL
        (data.showCtaOnCtaPage || !urlsAreEqual(data.cta.url, currentUrl)));
}
// Whether to show a Secondary CTA in the CTASubnav
export function shouldRenderSecondaryCta({ data, loggedIn = false, cartCount = 0 }) {
    return (Boolean(data.secondaryCta) &&
        // CTA is not filtered out by logged in or cart state
        shouldRenderNavItem({
            item: data.secondaryCta,
            loggedIn,
            cartCount,
        }));
}
// Filter an array of nav items
export function filterNavItems({ items = [], loggedIn = false, cartCount = 0 }) {
    if (!items) {
        return [];
    }
    return items.filter((item) => shouldRenderNavItem({
        item,
        loggedIn,
        cartCount,
    }));
}
